import { Pass, ProductFamily, Reservation } from 'app/services/GuestCenterService.types';

export function getAttractionTickets(
  passes: Maybe<Pass[]>,
  reservations?: Maybe<Reservation[]>,
  productLineup?: { familyCode?: string }
): string[] {
  const attractionKeyMap: { [attractionKey: string]: boolean } = {};

  if (productLineup?.familyCode === ProductFamily.Alacarte) {
    passes?.forEach((pass) => {
      pass.tickets?.forEach((ticket) => {
        if (ticket.attractionKey) {
          attractionKeyMap[ticket.attractionKey] = true;
        }
      });
    });
  } else if (reservations && passes) {
    const passBarcodes = new Set(passes.map((pass) => pass.barcode));
    reservations.forEach((reservation) => {
      reservation.tickets?.forEach((ticket) => {
        if (ticket.passBarcode && passBarcodes.has(ticket.passBarcode)) {
          attractionKeyMap[ticket.attractionKey] = true;
        }
      });
    });
  }

  return Object.keys(attractionKeyMap);
}
